<script setup lang="ts">
const items = [
  {
    label: 'Wat doet Juiste Makelaar?',
    content:
      'Wij zijn een makelaar vergelijkingsdienst die actief is in heel Nederland. Op basis van jouw voorkeuren en onze unieke makelaarsdatabase matchen wij jou aan de beste makelaar voor jouw situatie. Voordat we je in contact brengen nemen wij contact met je op om de matching compleet te maken. Zo sta je niet voor verrassingen. Vervolgens ontvang je de geselecteerde makelaars per mail en nemen zij zelf contact met je op. Daarna kies jij de beste makelaar voor jouw situatie.',
  },
  {
    label: 'Hoe vergelijken jullie makelaars?',
    content:
      'In de aanvraag vragen wij een aantal voorkeuren dit combineren wij met de beschikbare makelaarsdata. Nadat je deze gegevens hebt ingevuld nemen we altijd persoonlijk contact op zodat we de gehele vergelijking compleet kunnen maken.',
  },
  {
    label: 'Waarom is het vergelijken van makelaars nodig?',
    content:
      'In Nederland zijn meer dan 9.000 actieve makelaars. Op deze manier is het moeilijk om te bepalen welke makelaar het beste past bij jouw situatie. Welke makelaar hanteert een goede aan- of verkoopstrategie en welke kosten rekenen de verschillende makelaars. Nieuwsgierig geworden? Doe direct de vergelijking!',
  },
  {
    label: 'Kan ik overal in Nederland makelaars vergelijken?',
    content:
      'Ja! Wij kunnen je in heel Nederland helpen aan een geschikte makelaar. Dit komt mede door onze vele partners, waardoor wij overal in Nederland je zo goed mogelijk kunnen helpen.',
  },
  {
    label: 'Wat is een normale courtage van een makelaar?',
    content:
      'De gemiddelde verkoopcourtage van een makelaar in Nederland ligt tussen de 1 en 1,25 procent. Echter hangt dit natuurlijk af van wat je afspreekt met de desbetreffende makelaar. Je kunt hierbij denken aan een bonusafspraak of een ander takenpakket.',
  },
  {
    label: 'Wat kost een aankoopmakelaar?',
    content:
      'De gemiddelde makelaarscourtage in Nederland bij een aankoopmakelaar ligt tussen de 0,5 en 1,0 procent van het aankoopbedrag. Bij de aankoopmakelaar hangt de courtage af van de aankoopsom, de werkzaamheden en de woonplaats waar je een woning wilt kopen. Is de plaats of buurt erg populair? Dan kan de makelaar hogere kosten in rekening brengen.',
  },
  {
    label: 'Wat gebeurt er als ik de vergelijking heb afgerond?',
    content:
      'Direct na het invullen van je voorkeuren, ontvang je een bevestiging. Daarna nemen we telefonisch contact op, tenzij je liever op een andere manier contact wilt hebben. Wanneer alles naar wens is zullen daarna de twee geselecteerde makelaars contact opnemen. Tot slot maak je zelf de keuze met welke makelaar je de beste klik hebt en met wie je wilt samenwerken.',
  },
  {
    label: 'Kan ik ook een prijslijst van makelaars krijgen?',
    content:
      'Nee, omdat alle makelaars in Nederland een andere werkwijze hebben is het nog niet mogelijk om een standaard prijslijst te sturen. Dit komt mede door verschillende aspecten, zoals dat je met makelaars prestatiebonussen kunt afspreken waardoor het standaardcourtage lager is, of dat je zelf een aantal taken zelf uitvoert. Andere redenen om geen standaardprijslijst te kunnen geven zijn: de verkoopranges van makelaarsverschillen, de locatie van je woning, kwaliteit van de makelaar en extra services die makelaars aanbieden.',
  },
  {
    label: 'Is deze aanvraag via Juiste Makelaar gratis?',
    content:
      'Jazeker! Deze aanvraag is voor jou helemaal gratis. We brengen je graag gratis en vrijblijvend in contact met de geselecteerde makelaars. Op het moment dat je uiteindelijk succesvol bent geholpen met het kopen of verkopen van je woning, dan vragen wij een kleine vergoeding aan de makelaar, wat inhoud dat er voor jou geen kosten aan zijn verbonden.',
  },
]

const content = {
  title: 'Veelgestelde vragen',
  description: 'Heb je vragen? Hier staan de meest gestelde vragen.',
}
</script>

<template>
  <section class="py-16">
    <UContainer>
      <div class="text-center mb-10">
        <h2 class="text-3xl sm:text-4xl font-bold tracking-[-0.015em] text-highlighted text-balance mb-2">
          {{ content.title }}
        </h2>
        <p class="text-muted text-lg text-pretty">
          {{ content.description }}
        </p>
      </div>

      <div class="max-w-2xl mx-auto">
        <Faq :items="items" />
      </div>
    </UContainer>
  </section>
</template>
